import { FvButton } from '@fv/client-components'

import { ShipperTooltip } from '@/components/ShipperTooltip'

import { useNmfcArticleSearch } from './queries'

type NoteTooltipProps = {
  nmfcNumber: string
}

export const NoteTooltip = ({ nmfcNumber }: NoteTooltipProps) => {
  const note = useNmfcArticleSearch({ code: nmfcNumber })

  return (
    <ShipperTooltip label={note.data?.description}>
      <FvButton theme="underlined" className="m-0">
        {nmfcNumber}
      </FvButton>
    </ShipperTooltip>
  )
}
